import { FC, useState } from "react"
import { useFindWorklowsQuery } from "../../../../../redux/queries"
import { Integration } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import Form from "../../../form"

interface Props {
  integration: Integration
}

const LeadWorkflowSelector: FC<Props> = ({ integration }) => {
  const { app_settings, saveAppSetting } =
    useIntegrationSettingsForm(integration)

  const [selectedID, setSelectedWorkflowID] = useState<string>(
    String(app_settings?.lead_workflow ?? "")
  )

  const { data: workflows = [], isLoading } = useFindWorklowsQuery(
    integration.brand_id,
    { skip: !integration.brand_id }
  )

  const setSelected = (workflowID: string) => {
    if (workflowID !== selectedID) {
      setSelectedWorkflowID(workflowID)
      saveAppSetting({ lead_workflow: workflowID })
    }
  }

  return (
    <Form.Select
      label="Choose a workflow"
      showLabel={false}
      size="sm"
      isLoading={isLoading}
      data={workflows}
      setSelected={setSelected}
      selected={selectedID || undefined}
    />
  )
}

export default LeadWorkflowSelector
